import React, { PropsWithChildren, useState } from 'react';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Modal } from '../layout';
import { IconButton } from './IconButton';

export const InfoButton: React.FC<PropsWithChildren> = (props) => {
    const [showingModal, setShowingModal] = useState<boolean>(false);
    const onClose = () => {
        setShowingModal(false);
    };

    return (
        <span>
            <IconButton
                onClick={() => {
                    setShowingModal(true);
                }}
                label={'Please click icon for additional information'}
                mode={faInfoCircle}
            />
            <Modal
                title="Info"
                size="lg"
                open={showingModal}
                rightButtons={[
                    {
                        label: 'Close',
                        onClick: onClose,
                        mode: 'secondary',
                    },
                ]}
                id="modal-popup"
                onClose={() => {
                    onClose();
                }}>
                <span style={{fontWeight: 'normal'}}>
                    {props.children}
                </span>
            </Modal>
        </span>
    )
}